export const formatNumber = (amount, minimumFractionDigits = 2) => {
  const formatter = new Intl.NumberFormat("de-DE", {
    maximumFractionDigits: minimumFractionDigits,
    minimumFractionDigits
  });
  return formatter.format(Number(amount));
};
